export default __webpack_public_path__ + "static/media/bg-valdano-mentor@2x.897cc9f8.jpg";